export default __webpack_public_path__ + "static/media/bell.c3b3e1f4.svg";